// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__oKxzh","rotation":"Spinner_rotation__jF5b4","sm":"Spinner_sm__aXPV1"};